module.exports = __webpack_public_path__ + "static/img/1050.1330d4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/image/1050.png
// module id = I+wM
// module chunks = 0